import Vue from 'vue'
import App from './App.vue'
import router from "@/router";
import store from "@/store";
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/icons/iconfont.css'

Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
  store,
  router,
  beforeCreate () {
    Vue.prototype.$bus = this // 安装全局事件总线
  },
  render: (h) => h(App)
}).$mount('#app')
